import page from '@src/layout/page.vue'

import { Route } from '../ARoute'

function userLazyload(view) {
  return () =>
    import(/* webpackChunkName: "view-system-" */ `@src/views/system/${view}`)
}
export default Route.withPath('', page).withChildren([
  Route.withPageLayout('he-thong').withChildren([
    Route.redirect('', { name: 'users' }).withName('system'),
    Route.withPath('nguoi-dung', userLazyload('user/user-table.vue'))
      .withName('users')
      .withTitle('sidebar.users.name')
      .requireHasAnyInScopes(['user-management']),
    // Route.withPath('vai-tro', userLazyload('role-table.vue'))
    //   .withTitle('sidebar.roles.name')
    //   .withName('system.roles'),
    // Route.withPath('nhom', userLazyload('group/GroupMain.vue'))
    //   .withTitle('sidebar.groups.name')
    //   .withName('system.groups'),
    // Route.withPath('permissions', lazyload('system/permission-table.vue'))
    //   .withTitle('sidebar.permissions.name')
    //   .withName('system.permissions'),
  ]),
])
